module.exports = __webpack_public_path__ + "img/lanhu-logo.9f6f2580.svg";